module.exports = __webpack_public_path__ + "a6389d8eb87a8940a1050e8ec56e2c83.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/umbrella-purple-s.png
// module id = 2336
// module chunks = 0